import { itemCategoryUpdateApi } from "../../api/itemCategory/itemCategoryUpdateApi"

type PayloadShape = Parameters<typeof itemCategoryUpdateApi>[0]

export async function itemCategoryUpdateService(payload: PayloadShape, token: string) {
	return await itemCategoryUpdateApi(payload, token)
}
